module.exports = __webpack_public_path__ + "img/emoji/biblethump.58b88e4a8f338cc90003cc2051c2bea8.png";